import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { VslPlayer } from './ui/VslPlayer';
import { LOGO_URL } from '../data/site';
const EASE = [0.23, 1, 0.32, 1] as const;
export function HeroSection() {
  return <header className="relative overflow-hidden bg-ivory" data-id="element-122" data-mp="28tv21ctzzvm2">
      <div className="mx-auto max-w-6xl px-6 pt-10 pb-16 sm:pt-14 lg:px-8 lg:pt-16 lg:pb-24" data-id="element-123" data-mp="28uefag8pdvtr">
        <motion.img src={LOGO_URL} alt="La Herradura Dorada · Mentoría 1:1 con Careliz Griman" initial={{
        opacity: 0,
        y: -12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: EASE
      }} className="mx-auto w-36 sm:w-44 lg:w-48" data-id="element-124" data-mp="2wkijaopszxla" />

        <div className="mt-9 grid items-center gap-11 lg:mt-12 lg:grid-cols-[1fr_1.05fr] lg:gap-14" data-id="element-125" data-mp="2rqns707vcgc6">
          {/* Copy + CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.15,
          ease: EASE
        }} className="text-center lg:text-left" data-id="element-126" data-mp="3k9telqodwzs1">
            <p className="text-[10px] font-medium uppercase tracking-[0.28em] text-gold-dark sm:text-[11px]" data-id="element-127" data-mp="2bfhx47un0uig">
              Una experiencia privada de reconexión y claridad
            </p>

            <h1 className="mt-6 font-serif text-[1.9rem] font-light leading-[1.15] text-ink sm:text-[2.75rem] lg:text-[3rem]" data-id="element-128" data-mp="2kdtle3817g7q">
              ¿Y si el problema no fuera que te falta capacidad…{' '}
              <em className="not-italic text-gold-dark" data-id="element-129" data-mp="2u3mvezsizn9v">
                sino que estás desconectada de la mujer que ya eres?
              </em>
            </h1>

            <p className="mx-auto mt-6 max-w-xl text-[17px] leading-relaxed text-ink-soft sm:text-[19px] lg:mx-0" data-id="element-130" data-mp="335co08y58s98">
              Descubre qué podría estar bloqueando tu siguiente nivel y recibe
              claridad sobre el camino que necesitas comenzar a recorrer para
              recuperar tu seguridad, tu energía y tu dirección.
            </p>

            <div className="mt-8 flex flex-col items-center gap-4 lg:items-start" data-id="element-131" data-mp="38v5uv4nkxwrj">
              <CtaButton targetId="test" size="lg" pixelEvent="StartTrial" pixelParams={{
              content_name: 'Hero — Descubrir mi bloqueo'
            }} data-id="element-132" data-mp="3dt7f3swqs24l">
                Quiero descubrir mi bloqueo
              </CtaButton>
              <p className="text-[11px] uppercase tracking-[0.16em] text-ink-muted" data-id="element-133" data-mp="3rr5r4rnlbmgx">
                Sesión privada 1:1 · 45 minutos · Online
              </p>
            </div>
          </motion.div>

          {/* VSL */}
          <Reveal delay={0.25} data-id="element-134" data-mp="5d4gecnlxnse">
            <VslPlayer data-id="element-135" data-mp="abpikhmf6hjh" />
          </Reveal>
        </div>
      </div>
    </header>;
}